import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  Button,
  FormControl,
  InputGroup,
  Container,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import FormContainer from "../../../components/formContainer";
import { createProduct } from "../../../actions/product";
import Message from "../../../components/message";
import Loader from "../../../components/loader";
import { Link } from "react-router-dom";
import { CREATE_PRODUCT_RESET } from "../../../actions/types";
import ShowImageForAdmin from "../../../components/showImageForAdmin";
import Editor from "../Editor";
import ShowSavedProductDetail from "./showSavedProductDetail";
import ShowCreatedProductDetails from "./showCreatedProductDetails";
import CarrierCompatibilityItems from "./CarrierCompItems";

const NewProductScreen = ({ match, history }) => {
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [isFeatured, setIsFeatured] = useState(false);
  const [feature, setFeature] = useState("");
  const [description, setDescription] = useState("");
  const [style, setStyle] = useState("");
  const [rating, setRating] = useState("");
  const [material, setMaterial] = useState("");
  //
  const [chips, setChips] = useState([]);
  //
  const [richTextContent, setRichTextContent] = useState("");

  const [capacity, setCapacity] = useState("");
  const [color, setColor] = useState("");
  const [stock, setStock] = useState();
  const [price, setPrice] = useState();
  const [discount, setDiscount] = useState();
  //
  const [imageArr, setImageArr] = useState([]);
  const [productDetailTemp, setProductDetailTemp] = useState();
  const [createdProductDetail, setCreatedProductDetail] = useState([]);

  const dispatch = useDispatch();

  const userAuth = useSelector((state) => state.userAuth);
  const { userInfo } = userAuth;

  const productCreate = useSelector((state) => state.productCreate);
  const { loading, error, product: productMessage } = productCreate;

  const nameRef = useRef(null);
  const categoryRef = useRef(null);
  const featureRef = useRef(null);
  const descriptionRef = useRef(null);
  const styleRef = useRef(null);
  const ratingRef = useRef(null);
  const materialRef = useRef(null);
  const capacityRef = useRef(null);
  const colorRef = useRef(null);
  const stockRef = useRef(null);
  const priceRef = useRef(null);
  const discountRef = useRef(null);
  //
  const productDetailRef = useRef(null);
  //
  const imageArrRef = useRef(null);

  const elementsRefs = {
    name: nameRef,
    category: categoryRef,
    feature: featureRef,
    description: descriptionRef,
    style: styleRef,
    rating: ratingRef,
    material: materialRef,
    capacity: capacityRef,
    color: colorRef,
    stock: stockRef,
    price: priceRef,
    discount: discountRef,
    //
    productDetail: productDetailRef,
    //
    image: imageArrRef,
  };

  useEffect(() => {
    if (!userInfo) {
      history.push("/login");
    }

    if (userInfo.role !== "admin") {
      history.push("/");
    }
    if (productMessage) {
      setTimeout(() => {
        dispatch({ type: CREATE_PRODUCT_RESET });
      }, 1500);
      //
    }
  }, [dispatch, history, match, userInfo, productMessage]);

  const [validationErrors, setValidationErrors] = useState({});

  const uploadImage = (base64EncodedImage) => {
    return base64EncodedImage;
  };

  const handleCreateProduct = (e) => {
    e.preventDefault();
    let errors = {};

    if (!name || name.trim() === "") {
      errors.name = "Product Name is required.";
    }

    if (!category || category.trim() === "") {
      errors.category = "Category is required.";
    }

    if (!feature || feature.trim() === "") {
      errors.feature = "Feature is required.";
    }

    if (!description || description.trim() === "") {
      errors.description = "Description is required.";
    }

    if (!style || style.trim() === "") {
      errors.style = "Style is required.";
    }

    if (!rating || rating < 0 || rating > 5) {
      errors.rating = "Rating must be between 0 and 5.";
    }

    if (!productDetailTemp && createdProductDetail.length === 0) {
      errors.productDetail = "Product details are required";
    }

    if (!material || material.trim() === "") {
      errors.material = "Material information is required.";
    }

    const firstErrorField = Object.keys(errors)[0];
    const firstErrorRef = elementsRefs[firstErrorField];

    if (firstErrorRef && firstErrorRef.current) {
      const yOffset = -100;
      const y =
        firstErrorRef.current.getBoundingClientRect().top +
        window.scrollY +
        yOffset;

      window.scrollTo({ top: y - 150, behavior: "smooth" });
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors({ ...errors });
      return;
    }

    setValidationErrors({});

    const firstImages = createdProductDetail
      .flatMap((product) =>
        product.details.map((detail) =>
          detail.images.length > 0 ? detail.images[0].url : null
        )
      )
      .filter((img) => img !== null);

    const productCreationDetail = {
      productName: name,
      category,
      image: firstImages.slice(0, 3),
      isFeatured,
      feature,
      description,
      style,
      rating,
      material,
      carrierComp: chips,
      richText: richTextContent,
      capacity: createdProductDetail,
    };

    dispatch(createProduct(productCreationDetail));
  };

  useEffect(() => {
    if (productMessage) {
      setName("");
      setCategory("");
      setIsFeatured(false);
      setFeature("");
      setDescription("");
      setStyle("");
      setRating("");
      setMaterial("");
      //
      setCreatedProductDetail([]);
    }
  }, [productMessage]);

  const handleCreateProductDetails = (e) => {
    e.preventDefault();

    let errors = {};

    if (productDetailTemp && productDetailTemp.capacity === "") {
      errors.productDetail = "Capacity is required";
    }

    if (productDetailTemp && productDetailTemp.details.length === 0) {
      errors.productDetail = "Product details are required";
    }

    if (productDetailTemp && productDetailTemp.details.length) {
      for (let index = 0; index < productDetailTemp.details.length; index++) {
        const detailObject = productDetailTemp.details[index];
        console.log(
          "productDetailTemp_productDetailTemp loop_object__",
          detailObject
        );
        if (detailObject.images.length === 0)
          errors.productDetail =
            "At least an image is required along with product details";
      }
    }

    const firstErrorField = Object.keys(errors)[0];
    const firstErrorRef = elementsRefs[firstErrorField];

    if (firstErrorRef && firstErrorRef.current) {
      const yOffset = -100;
      const y =
        firstErrorRef.current.getBoundingClientRect().top +
        window.scrollY +
        yOffset;

      window.scrollTo({ top: y - 150, behavior: "smooth" });
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors({ ...errors });
      return;
    }

    setValidationErrors({});
    //

    setCreatedProductDetail((prev) => [...prev, productDetailTemp]);
    setProductDetailTemp();
    setCapacity("");
  };

  const handleSaveProductDetail = () => {
    setValidationErrors({});

    let errors = {};

    if (!imageArr || imageArr.length === 0) {
      errors.image = "At least an image is required along with product details";
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors({ ...errors });
      return;
    }

    setValidationErrors({});

    const detailsObject = {
      color: color,
      quantity: stock ? Number(stock) : 0,
      price: Number(price),
      discount: discount ? Number(discount) : 0,
      images: imageArr.map((item) => uploadImage(item)),
    };

    let detailArr = [];
    if (!productDetailTemp) {
      detailArr = [detailsObject];
    } else {
      detailArr = [...productDetailTemp.details, detailsObject];
    }

    const productData = {
      capacity: capacity,
      details: detailArr,
    };

    setProductDetailTemp({ ...productData });

    setColor("");
    setStock("");
    setPrice("");
    setDiscount("");
    setImageArr([]);
  };

  // removing image-error upon saving the image
  useEffect(() => {
    let errors = {};

    if (imageArr || imageArr.length > 0) {
      errors.image = "";
    }

    if (capacity || capacity.trim() !== "") {
      errors.capacity = "";
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors({ ...errors });
      return;
    }

    setValidationErrors({});
  }, [capacity, imageArr]);

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    console.log(file);
    previewFile(file);
    e.target.value = "";
  };

  const previewFile = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setImageArr((prevImages) => [
        ...prevImages,
        { name: file.name, url: reader.result },
      ]);
    };
  };

  const UPLOADINGIMAGELIMIT = 6;
  return (
    <Container>
      <Link to="/admin/productlist" className="btn btn-light my-3">
        Go Back
      </Link>
      {productMessage && <Message variant="success">{productMessage}</Message>}
      <FormContainer>
        <h1>CREATE PRODUCT</h1>
        {error && <Message variant="danger">{error}</Message>}

        {loading ? (
          <Loader />
        ) : (
          <Form onSubmit={handleCreateProduct} autoComplete="on">
            <h5 className="mt-4">Product Name</h5>
            <div>
              <FormControl
                value={name || ""}
                placeholder="Product Name"
                onChange={(e) => setName(e.target.value)}
                ref={elementsRefs.name}
              />
              {validationErrors.name && (
                <small className="text-danger">{validationErrors.name}</small>
              )}
            </div>

            <h5 className="mt-4">Brand</h5>
            <div>
              <FormControl
                placeholder="Brand"
                onChange={(e) => setCategory(e.target.value)}
                value={category}
                ref={elementsRefs.category}
              />
              {validationErrors.category && (
                <small className="text-danger">
                  {validationErrors.category}
                </small>
              )}
            </div>

            <Form.Group className="py-2">
              <h5>is-Featured</h5>
              <Form.Select
                onChange={(e) => setIsFeatured(e.target.value)}
                value={isFeatured}
              >
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </Form.Select>
            </Form.Group>

            <>
              <h5 className="mt-4">Feature</h5>
              <div>
                <FormControl
                  placeholder="Feature"
                  onChange={(e) => setFeature(e.target.value)}
                  value={feature}
                  ref={elementsRefs.feature}
                />
                {validationErrors.feature && (
                  <small className="text-danger">
                    {validationErrors.feature}
                  </small>
                )}
              </div>

              <CarrierCompatibilityItems setChips={setChips} />

              <h5 className="mt-4">Description</h5>
              <div>
                <FormControl
                  placeholder="Description"
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                  ref={elementsRefs.description}
                />
                {validationErrors.description && (
                  <small className="text-danger">
                    {validationErrors.description}
                  </small>
                )}
              </div>

              <h5 className="mt-4">Style</h5>
              <div>
                <FormControl
                  placeholder="Style"
                  onChange={(e) => setStyle(e.target.value)}
                  value={style}
                  ref={elementsRefs.style}
                />
                {validationErrors.style && (
                  <small className="text-danger">
                    {validationErrors.style}
                  </small>
                )}
              </div>

              <h5 className="mt-4 mb-3">Rating</h5>
              <div>
                <InputGroup size="sm">
                  <FormControl
                    type="number"
                    placeholder="Rating"
                    value={rating}
                    onChange={(e) => setRating(e.target.value)}
                    max="5"
                    min="0"
                    ref={elementsRefs.rating}
                  />
                </InputGroup>
                {validationErrors.rating && (
                  <small className="text-danger">
                    {validationErrors.rating}
                  </small>
                )}
              </div>
            </>

            <div>
              <ShowCreatedProductDetails
                createdProductDetail={createdProductDetail}
                setCreatedProductDetail={setCreatedProductDetail}
              />

              <div>
                <h4 className="mt-5">Enter product capacity and details</h4>
                <FormControl
                  placeholder="Enter product capacity in GB"
                  value={capacity}
                  // onChange={(e) => setCapacity(e.target.value)}
                  onChange={(e) => {
                    setCapacity(e.target.value);
                    if (productDetailTemp) {
                      setProductDetailTemp({
                        ...productDetailTemp,
                        capacity: e.target.value,
                      });
                    }
                  }}
                  ref={elementsRefs.productDetail}
                />
                {validationErrors.productDetail && (
                  <small className="text-danger">
                    {validationErrors.productDetail}
                  </small>
                )}
              </div>

              <ShowSavedProductDetail
                productDetailTemp={productDetailTemp}
                setProductDetailTemp={setProductDetailTemp}
              />

              <h5 className="mb-3 mt-4">Image</h5>
              <Form.Group>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      You can only upload up to {UPLOADINGIMAGELIMIT} images.
                    </Tooltip>
                  }
                  show={imageArr.length >= UPLOADINGIMAGELIMIT} // Tooltip shown only if there are 2 or more images
                >
                  <span>
                    <Form.Control
                      type="file"
                      onChange={handleFileInputChange}
                      disabled={imageArr.length >= UPLOADINGIMAGELIMIT} // Disable if 2 or more images
                      style={
                        imageArr.length >= UPLOADINGIMAGELIMIT
                          ? { cursor: "not-allowed" }
                          : {}
                      }
                    />
                    {validationErrors.image && (
                      <small className="text-danger">
                        {validationErrors.image}
                      </small>
                    )}
                  </span>
                </OverlayTrigger>
              </Form.Group>

              {imageArr.length > 0 && (
                <ShowImageForAdmin
                  create
                  source={imageArr}
                  handleRemoveImage={(index) => {
                    const updatedImages = [...imageArr];
                    updatedImages.splice(index, 1);
                    setImageArr(updatedImages);
                  }}
                  ref={elementsRefs.image}
                />
              )}

              {/* product detail selection */}
              <div className="mb-3">
                <InputGroup className="my-2">
                  <InputGroup.Text>Details</InputGroup.Text>
                  <FormControl
                    placeholder="Color"
                    value={color}
                    onChange={(e) => setColor(e.target.value)}
                    ref={elementsRefs.color}
                  />

                  {/* Price Input */}
                  <FormControl
                    type="number"
                    placeholder="Price in USD"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    min={0}
                    ref={elementsRefs.price}
                  />

                  {/* Discount Input */}
                  <FormControl
                    type="number"
                    placeholder="Discount"
                    value={discount}
                    onChange={(e) => setDiscount(e.target.value)}
                    min={0}
                    ref={elementsRefs.discount}
                  />

                  {/* Stock Input */}
                  <FormControl
                    type="number"
                    placeholder="Stock"
                    value={Number(stock)}
                    onChange={(e) => setStock(e.target.value)}
                    min={0}
                    ref={elementsRefs.stock}
                  />

                  {/* Add Button */}
                  <Button
                    variant="primary"
                    className="btn-sm"
                    onClick={handleSaveProductDetail}
                    disabled={!color || !price}
                    style={{
                      backgroundColor: "#0d6efd",
                      color: "white",
                    }}
                  >
                    <i className="fas fa-plus" />
                  </Button>
                </InputGroup>
              </div>

              <InputGroup size="sm" className="">
                <Button
                  className="btn-sm"
                  disabled={!productDetailTemp}
                  onClick={handleCreateProductDetails}
                  style={{
                    backgroundColor: "#0d6efd",
                    color: "white",
                  }}
                >
                  Save Product
                </Button>
              </InputGroup>
            </div>

            <Editor content={richTextContent} setContent={setRichTextContent} />

            <>
              <h5 className="mt-4">Material</h5>
              <div>
                <FormControl
                  placeholder="Material"
                  onChange={(e) => setMaterial(e.target.value)}
                  value={material}
                  ref={elementsRefs.material}
                />
                {validationErrors.material && (
                  <small className="text-danger">
                    {validationErrors.material}
                  </small>
                )}
              </div>

              <div className="py-4">
                <Button
                  type="submit"
                  variant="primary"
                  style={{
                    backgroundColor: "#0d6efd",
                    color: "white",
                  }}
                >
                  CREATE PRODUCT
                </Button>
              </div>
            </>
          </Form>
        )}
      </FormContainer>
    </Container>
  );
};

export default NewProductScreen;
